/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        badge: {
            fontWeight: {
                value: 600,
                type: "fontWeight",
            },
            backgroundColor: {
                value: "#E71613",
                type: "color",
            },
            color: {
                value: "#ffffff",
                type: "color",
            },
            small: {
                width: {
                    value: "16px",
                    type: "dimension",
                },
                height: {
                    value: "16px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                paddingHorizontal: {
                    value: "4.5px",
                    type: "dimension",
                },
            },
            large: {
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                paddingHorizontal: {
                    value: "8px",
                    type: "dimension",
                },
            },
            indicator: {
                width: {
                    value: "8px",
                    type: "dimension",
                },
                height: {
                    value: "8px",
                    type: "dimension",
                },
            },
            counter: {
                height: {
                    value: "16px",
                    type: "dimension",
                },
                paddingHorizontal: {
                    value: "4px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                borderColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                borderWidth: {
                    value: "0",
                    type: "dimension",
                },
                borderRadius: {
                    value: "2px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                large: {
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
